export function capitalizeFirstLetterOfString(str: string) {
  return str[0]!.toUpperCase() + str.slice(1);
}

export function isEmptyString(value: string | undefined | null): boolean {
  return !value || value.trim() === '';
}
